export default __webpack_public_path__ + "static/media/diagonal_arrow.79404545.svg";